export const ALERTS_TABLE = {
  colName: 'calc(55% - 216px)',
  colLevel: '62px',
  colTime: '190px',
  colHost: 'calc(45% - 196px)',
  colValue: '160px',
}
